module.exports = __webpack_public_path__ + "img/recuperi-650x650.fc0394ad.png";